export default function clearPredefinedFields (state, action) {
	  return {
		...state,
		view: {
		  	...state.view,
		  	predefinedFields: action.payload
		},
	  };
}